function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.364 16.364a9 9 0 0 0 0-12.728 9 9 0 0 0-12.728 0 9 9 0 0 0 0 12.728 9 9 0 0 0 12.728 0ZM6.111 6.111a1.5 1.5 0 0 1 2.121 0L10 7.879l1.768-1.768a1.5 1.5 0 1 1 2.121 2.121L12.121 10l1.768 1.768a1.5 1.5 0 1 1-2.121 2.121L10 12.121l-1.768 1.768a1.5 1.5 0 1 1-2.121-2.121L7.879 10 6.111 8.232a1.5 1.5 0 0 1 0-2.121Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgXCircle;